import { useState } from 'react';

interface UseDropdownStateOptions {
	defaultValue?: any;
	onChange?: (value: any) => void;
	value?: any;
}

export const useDropdownState = ({ defaultValue, onChange, value }: UseDropdownStateOptions) => {
	const [selectedValue, setSelectedValue] = useState(defaultValue);

	return {
		defaultValue,
		onChange: typeof onChange === 'undefined' ? setSelectedValue : onChange,
		value: typeof value === 'undefined' ? selectedValue : value,
	};
};
